import Vue from "vue";
import Router from "vue-router";
import { getUser, hasAuth } from "@/server/authStorage";
import { redirectLegacyResetPasswordHash } from "@/utils/authNavigationPrivacy";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import NotFound from "@/views/NotFound.vue";

import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import Home from "@/views/HomeView.vue";
import DiscoverView from "@/views/DiscoverView.vue";
import DiscoverAgendados from "@/views/DiscoverAgendados.vue";
import DiscoverCategories from "@/views/DiscoverCategories.vue";
import DiscoverBiblioteca from "@/views/DiscoverBiblioteca.vue";
import ObraOpenView from "@/views/ObraOpenView.vue";
import ObraPageView from "@/views/ObraPageView.vue";
import AuthorView from "@/views/AuthorView.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import AdminPanelLayout from "@/layouts/AdminPanelLayout.vue";
import PainelUserCreator from "@/views/PainelUserCreator.vue";
import ProfilerUserView from "@/views/ProfilerUserView.vue";
import PostWorkView from "@/views/PostWorkView.vue";
import PostBannerView from "@/views/PostBannerView.vue";
import WarningsView from "@/views/WarningsView.vue";
import ListCapituloView from "@/views/ListCapituloView.vue";
import ListPagesCapituloView from "@/views/ListPagesCapituloView.vue";
import AdmDashboardView from "@/views/AdmDashboardView.vue";
import AdmAcessUserView from "@/views/AdmAcessUserView.vue";
import AdmModeradoresView from "@/views/AdmModeradoresView.vue";
import EditPorfileView from "@/views/EditPorfileView.vue";
import EditorView from "@/views/EditorView.vue";
import CreateChapterBookView from "@/views/CreateChapterBookView.vue";
import ReadingPageView from "@/views/ReadingPageView.vue";
import Notifications from "@/views/Notifications.vue";
import BlogView from "@/views/BlogView.vue";
import BlogPostView from "@/views/BlogPostView.vue";
import BlogSavedView from "@/views/BlogSavedView.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import HelpeView from "@/views/HelpeView.vue";
import GenderView    from '@/views/gender/GenderView.vue';
import AgeRatingView from '@/views/age-rating/AgeRatingView.vue';
import ZinnesView from "../views/ZinnesView.vue";
import MarketPlaceView from "../views/MarketPlaceView.vue";
import AdminHomeExclusivesView from "@/views/AdminHomeExclusivesView.vue";
import SocialModerationView from "@/views/social/SocialModerationView.vue";

Vue.use(Router);

function redirectLegacyProjectHashToCleanPath() {
  if (typeof window === "undefined") return;

  if (redirectLegacyResetPasswordHash(window.location)) return;

  const hashPath = window.location.hash.replace(/^#/, "");
  const isLegacyProjectHash = /^\/obra\/\d+(\/[^/]+)?$/.test(hashPath);

  if (!isLegacyProjectHash) return;

  window.location.replace(`${window.location.origin}${hashPath}`);
}

redirectLegacyProjectHashToCleanPath();

const router = new Router({
  mode: "history",
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/termos-de-uso',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    {
      path: '/politica-de-privacidade',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/ajuda-suporte',
      name: 'HelpSupport',
      component: HelpeView
    },
    {
      path: "/login",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "Login",
          component: Login,
        },
      ],
    },
    {
      path: "/forgot-password",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "ForgotPassword",
          component: ForgotPassword,
        },
      ],
    },
    {
      path: "/reset-password",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "ResetPassword",
          component: ResetPassword,
        },
      ],
    },
    {
      path: "/cadastro",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "Register",
          component: Register,
        },
      ],
    },
    {
      path: "/nova-senha",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "ChangePassword",
          component: ChangePassword,
        },
      ],
    },
    {
      path: "/",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "Home",
          component: Home,
        },
        {
          path: "series",
          redirect: "/descobrir/categorias",
        },
        {
          path: "descobrir",
          component: DiscoverView,
          children: [
            {
              path: "",
              redirect: "/descobrir/categorias",
            },
            {
              path: "agendados",
              name: "DiscoverAgendados",
              component: DiscoverAgendados,
            },
            {
              path: "categorias",
              name: "DiscoverCategories",
              component: DiscoverCategories,
            },
            {
              path: "biblioteca",
              name: "DiscoverBiblioteca",
              component: DiscoverBiblioteca,
              meta: { requiresAuth: true },
            },
          ],
        },
        { path: "/comunidade", redirect: (to) => ({ name: "BlogHome", query: to.query }) },
        { path: "/comunidade/salvos", redirect: { name: "BlogSaved" } },
        { path: "/zinnes", component: ZinnesView },
        { path: "/marketplace", component: MarketPlaceView },
        { path: "/blog", redirect: (to) => ({ name: "BlogHome", query: to.query }) },
        { path: "/blog/salvos", redirect: { name: "BlogSaved" } },
        { path: "/blog/:slug", redirect: (to) => ({ name: "BlogPost", params: { slug: to.params.slug }, query: to.query }) },
        { path: "/portal-zinnes", name: "BlogHome", component: BlogView, meta: { socialRoute: true } },
        { path: "/portal-zinnes/salvos", name: "BlogSaved", component: BlogSavedView, meta: { socialRoute: true, requiresAuth: true } },
        { path: "/portal-zinnes/:slug", name: "BlogPost", component: BlogPostView, meta: { socialRoute: true } },
        {
          path: "/notifications",
          name: "UserNotifications",
          component: Notifications,
          props: true,
        },
        {
          path: ":idChapter/page",
          name: "ObraPage",
          component: ObraPageView,
          props: true,
        },
        {
          path: "obra/:idObra/:slug?",
          name: "ObraOpenView",
          component: ObraOpenView,
          props: true,
        },
        {
          path: "obra/book/reading/:idBook",
          name: "ReadingPageView",
          component: ReadingPageView,
          props: true,
        },
        {
          path: "",
        },
        {
          path: "autor/:authorId",
          name: "AuthorView",
          component: AuthorView,
          props: true,
        },
      ],
    },
    {
      path: "/dashboard",
      component: AdminPanelLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: "painel",
          name: "PainelUserCreator",
          component: PainelUserCreator,
        },
        {
          path: "user-profiler",
          name: "CardDatailsUser",
          component: ProfilerUserView,
        },
        {
          path: "publicar-obra",
          name: "PostWorkView",
          component: PostWorkView,
        },
        {
          path: "publicar-banner",
          name: "PostBannerView",
          component: PostBannerView,
          meta: { requiresAdmin: true },
        },
        {
          path: "avisos",
          name: "WarningsView",
          component: WarningsView,
          meta: { requiresAdmin: true },
        },
        {
          path: "obrar/:idObra",
          name: "ListCapituloView",
          component: ListCapituloView,
          props: true,
        },
        {
          path: "paginas_capitulos/:idCapitulo",
          name: "ListPagesCapituloView",
          component: ListPagesCapituloView,
          props: true,
        },
        {
          path: "adm_dashboard",
          name: "AdmDashboardView",
          component: AdmDashboardView,
          meta: { requiresAdmin: true },
        },
        {
          path: "adm_acess_user",
          name: "AdmAcessUserView",
          component: AdmAcessUserView,
          meta: { requiresAdmin: true },
        },
        {
          path: "adm_moderadores",
          name: "AdmModeradoresView",
          component: AdmModeradoresView,
          meta: { requiresAdmin: true },
        },
        {
          path: "publicar-banner",
          name: "PostBannerView",
          component: PostBannerView,
          meta: { requiresAdmin: true },
        },
        {
          path: "avisos",
          name: "WarningsView",
          component: WarningsView,
          meta: { requiresAdmin: true },
        },
        {
          path: "age-rating",
          name: "AgeRatingView",
          component: AgeRatingView,
          meta: { requiresAuth: true, requiresAdmin: true },
        },
        {
          path: "gender",
          name: "GenderView",
          component: GenderView,
          meta: { requiresAdmin: true },
        },
        {
          path: "admin/exclusivos-home",
          name: "AdminHomeExclusivesView",
          component: AdminHomeExclusivesView,
          meta: { requiresAuth: true, requiresAdmin: true },
        },
        {
          path: "moderacao-social",
          name: "SocialModeration",
          component: SocialModerationView,
          meta: { requiresAuth: true, requiresAdmin: true },
        },
        {
          path: "configuracao",
          name: "EditProfileView",
          component: EditPorfileView,
        },
        {
          path: "/editor",
          name: "EditorView",
          component: EditorView,
        },
        {
          path: "criar-capitulo-livro/:idObra",
          name: "CreateChapterBookView",
          component: CreateChapterBookView,
          props: true,
        },
      ],
    },
    {
      path: "*",
      component: NotFound,
    },
    {
      path: "page",
      name: "ObraPage",
      component: ObraPageView,
    },
  ],
});

// ---------------------------------------------------------------------------
// Route guard — redireciona para /login se rota requer autenticação
// ---------------------------------------------------------------------------
router.beforeEach((to, _from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);

  if (requiresAuth && !hasAuth()) {
    next({ path: "/login", query: { redirect: to.fullPath } });
  } else if (requiresAdmin) {
    try {
      const user = getUser();
      if (Number(user?.user_level_id) === 1) {
        next();
      } else {
        next("/dashboard/painel");
      }
    } catch (error) {
      next("/dashboard/painel");
    }
  } else {
    next();
  }
});

export default router;
